import { render, staticRenderFns } from "./MemcachedCacheConfig.vue?vue&type=template&id=8333a8d6&scoped=true&"
import script from "./MemcachedCacheConfig.vue?vue&type=script&lang=js&"
export * from "./MemcachedCacheConfig.vue?vue&type=script&lang=js&"
import style0 from "./MemcachedCacheConfig.vue?vue&type=style&index=0&id=8333a8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8333a8d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8333a8d6')) {
      api.createRecord('8333a8d6', component.options)
    } else {
      api.reload('8333a8d6', component.options)
    }
    module.hot.accept("./MemcachedCacheConfig.vue?vue&type=template&id=8333a8d6&scoped=true&", function () {
      api.rerender('8333a8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MemcachedCacheConfig.vue"
export default component.exports